import React, { useContext } from "react";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { useQuery } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";
import AllDraftModal from "./AllDraftModal";
import DraftCartItem from "./DraftCartItem";
import { CustomerContext } from "../CashierHomepage";

function CartHeader() {
  const { fetchData } = CashierApi();
  const {
    setOpenDraft,
    openDraft,
    setOpenMessage,
    setOpenGeneratePassword,
    setBarcodeScan,
  } = useContext(CustomerContext);
  const handleClose = () => setOpenDraft(false);

  const { data, isLoading } = useQuery({
    queryKey: ["draft"],
    queryFn: () => fetchData("orders/cashier-draft"),
    refetchOnWindowFocus: false,
    enabled: openDraft,
  });

  const handleAllDraft = () => {
    setOpenDraft(!openDraft);
    setOpenMessage(false);
    setOpenGeneratePassword(false);
    setBarcodeScan(false);
  };

  let draft = data;
  return (
    <header className="flex flex-row justify-between items-center mb-2">
      <PendingActionsIcon
        onClick={handleAllDraft}
        className="text-white cursor-pointer"
      />

      <h4 className="font-semibold text-2xl text-white">Cart</h4>
      <DraftCartItem />
      <AllDraftModal
        handleClose={handleClose}
        open={openDraft}
        draft={draft}
        setOpenDraft={setOpenDraft}
        isLoading={isLoading}
      />
    </header>
  );
}

export default React.memo(CartHeader);
